// extracted by mini-css-extract-plugin
module.exports = {"facilityCategory":"facility_category_facilityCategory__2gbsz","facilityTitle":"facility_category_facilityTitle__2chIY","subheading":"facility_category_subheading__1uqyI"};